import { render, staticRenderFns } from "./MealView.vue?vue&type=template&id=444a6084&"
import script from "./MealView.vue?vue&type=script&lang=js&"
export * from "./MealView.vue?vue&type=script&lang=js&"
import style0 from "./MealView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports